import {
  ASSESSMENT_QUESTIONS,
  formatAnswerDisplay,
  getRawAnswer,
} from "../data/assessmentQuestions";
import { readableTime, PATTERN_LABELS, DIMENSION_LABELS } from "../dashboard/analytics";

function formatDate(value) {
  if (!value) return "—";
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? String(value) : d.toLocaleString();
}

export function SubmissionDetail({ row }) {
  if (!row) return null;

  const name = row.full_name || row.name || "—";
  const email = row.email || "—";
  const tel = row.telemetry || {};
  
  const activeQuestions = ASSESSMENT_QUESTIONS;

  const hasScores =
    row.result &&
    (row.result.overall ||
      row.result.patternScores ||
      row.result.dimensionScores ||
      row.result.primary ||
      row.result.bottleneckType);

  return (
    <div className="submission-detail">
      <section className="submission-detail__section">
        <h3 className="submission-detail__h">Contact</h3>
        <p className="submission-detail__meta-line">
          <strong>{name}</strong>
          <span className="submission-detail__dot" aria-hidden />
          {email}
          <span className="submission-detail__dot" aria-hidden />
          ID {row.id ?? "—"}
          <span className="submission-detail__dot" aria-hidden />
          {formatDate(row.createdAt)}
        </p>
      </section>

      {hasScores && (
        <section className="submission-detail__section">
          <h3 className="submission-detail__h">Scored results</h3>
          <dl className="submission-kv">
            <div>
              <dt>Overall %</dt>
              <dd>{row.overallPercent ?? "—"}%</dd>
            </div>
            <div>
              <dt>Primary bottleneck</dt>
              <dd>{row.result?.badge || PATTERN_LABELS[row.primary] || row.primary || "—"}</dd>
            </div>
            {row.result?.secondary && (
              <div>
                <dt>Secondary pattern</dt>
                <dd>{row.result.secondary.rawPattern || row.result.secondary.name || "—"}</dd>
              </div>
            )}
          </dl>
          {row.patternScores && Object.keys(row.patternScores).length > 0 && (
            <ul className="pattern-scores-inline">
              {Object.entries(row.patternScores).map(([k, v]) => {
                const label = DIMENSION_LABELS[k] || PATTERN_LABELS[k] || k;
                const maxVal = DIMENSION_LABELS[k] ? 9 : 10;
                return (
                  <li key={k}>
                    <span>{label}</span>
                    <strong>{v}/{maxVal}</strong>
                  </li>
                );
              })}
            </ul>
          )}
        </section>
      )}

      {(tel.assessmentId || tel.totalTimeMs != null) && (
        <section className="submission-detail__section">
          <h3 className="submission-detail__h">Session</h3>
          <dl className="submission-kv">
            {tel.assessmentId && (
              <div>
                <dt>Assessment ID</dt>
                <dd className="submission-kv__mono">{tel.assessmentId}</dd>
              </div>
            )}
            {tel.totalTimeMs != null && (
              <div>
                <dt>Time to complete</dt>
                <dd>{readableTime(tel.totalTimeMs)}</dd>
              </div>
            )}
          </dl>
        </section>
      )}

      <section className="submission-detail__section">
        <h3 className="submission-detail__h">All answers ({activeQuestions.length} questions)</h3>
        <ol className="answer-list">
          {activeQuestions.map((q) => {
            const raw = getRawAnswer(row.answers, q.id);
            const display = formatAnswerDisplay(q, raw);
            return (
              <li key={q.id} className="answer-list__item">
                <div className="answer-list__qhead">
                  <span className="answer-list__num">Q{q.id}</span>
                  <span className="answer-list__cat">{q.category}</span>
                </div>
                <p className="answer-list__question">{q.question}</p>
                <div className="answer-list__answer">
                  {q.type === "text" ? (
                    <pre className="answer-list__text">{display === "—" ? "—" : display}</pre>
                  ) : (
                    <span>{display}</span>
                  )}
                </div>
              </li>
            );
          })}
        </ol>
      </section>
    </div>
  );
}
